export default {
  API_ENDPOINT: 'https://agile-tundra-03424.herokuapp.com/api',
  TOKEN_KEY: 'user-authentication-token',
};
